async function getAdvertisementDetail(businessId, id) {
  const responsePromise = await fetch('/advertisementDetail.json');
  return responsePromise.json();
}

export default getAdvertisementDetail;
